'use client'
import * as React from 'react'
import Image, { type ImageProps } from 'next/image'

// Unsplash occasionally 404s on legacy photo IDs, leaving a broken
// tile in the page. Wrap next/image with an onError handler that
// falls back to a single reliable hero photo (the Unsplash editorial
// "featured" stream which is publisher-rotated).
const FALLBACK_SRC = 'https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1200&h=800&q=80'

export function ResilientImage(props: ImageProps & { fallbackSrc?: string }) {
  const { src, fallbackSrc = FALLBACK_SRC, alt, onError, ...rest } = props
  const [current, setCurrent] = React.useState<string | typeof src>(src)
  return (
    <Image
      {...rest}
      src={current}
      alt={alt}
      onError={(e) => {
        if (current !== fallbackSrc) setCurrent(fallbackSrc)
        onError?.(e)
      }}
    />
  )
}
